import { registerBlockType } from "@wordpress/blocks";
import edit from "./edit";
import block from "./block.json";
import { createBlock } from '@wordpress/blocks';

/**
 * Register Block
 */
registerBlockType(block, {
  edit,
  transforms: {
    from: [
      {
        type: 'block',
        blocks: ['core/button'],
        transform: (attributes) => {
          return createBlock("neodigital/multi-file", {
            label: attributes.content || '',
          });
        },
      },
    ],
    to: [
      {
        type: 'block',
        blocks: ['core/button'],
        transform: ({ label }) => {
          return createBlock('core/button', {
            content: label || '',
          });
        },
      },
    ],
  },
});
